import styled from "styled-components";
import {
  ContentFormatter,
  Anchor,
  Button,
} from "@ebscois/react-component-library";

export const StyledReference = styled(ContentFormatter)`
  ${({ theme }) => `
    font-size: ${theme.font.size.sm};

    @media (min-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.font.size.md};
    }
  `}

  [data-element*="anchor"] {
    font-size: 1rem;
    text-decoration: underline;
  }
`;

export const TooltipWrapper = styled(ContentFormatter)`
  font-size: 0.75rem;

  [data-element*="anchor"] {
    font-size: 0.75rem;
    text-decoration: underline;
  }

  [class="li"] {
    display: contents;
  }

  ${({ theme }) => `
    width: 10rem;
    @media (min-width: ${theme.breakpoints.sm}) {
      width: 20rem;
    }

    @media (min-width: ${theme.breakpoints.md}) {
      width: 30rem;
    }
  `}
`;

export const StyledAnchor = styled(Anchor)`
  padding: 0.075rem;
`;

export const MobileTooltipTrigger = styled(Button)`
  color: ${({ theme }) => theme.colors.anchor};
  font-size: ${({ theme }) => theme.font.size.xs};
  padding: 0.075rem;
  text-decoration: none;
`;
